import React, { createContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import * as assets from '@assets';
import useQueryString from '@hooks/useQueryString';
import useDragAnimation from '@hooks/useDragAnimation';
import { requestEnumToString } from '@utils/enumToString';
import { RequestQueryString } from '../types';
import { useCommonLayoutStyles } from './styles';
import { CommonLayoutProps, DraggableContext } from './types';

export const DraggableControlContext = createContext<DraggableContext>({
  initializeStyle: null
});

const RequestCommonLayout: React.FC<CommonLayoutProps> = ({
  title,
  serviceExtraDescription,
  titleBackgroundColor,
  titleBackgroundImage,
  subButtonLabel,
  onClickSubButton,
  onClickClose,
  children,
  matches
}) => {
  const histroy = useHistory();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const headerRef = useRef<HTMLDivElement | null>(null);
  const titleWrapperRef = useRef<HTMLDivElement | null>(null);
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);
  const subButtonRef = useRef<HTMLButtonElement | null>(null);
  const pannelRef = useRef<HTMLDivElement | null>(null);
  const {
    query: { serviceType }
  } = useQueryString<RequestQueryString>();
  const { initializeStyle } = useDragAnimation({
    headerRef,
    titleWrapperRef,
    closeButtonRef,
    subButtonRef,
    pannelRef,
    hasBackgroundImage: Boolean(titleBackgroundImage)
  });
  const {
    container,
    header,
    titleWrapper,
    titleSection,
    contentSection
  } = useCommonLayoutStyles({
    titleBackgroundColor,
    titleBackgroundImage
  });

  const onClickLogo = () => {
    histroy.push({
      pathname: '/dashboard',
      state: {
        openRfqLeaveDialog: true
      }
    });
  };

  return (
    <div className={container} ref={containerRef}>
      <div className={header} ref={headerRef}>
        {!matches ? (
          <img
            src={assets.LOGO_MEDIUM_WHITE}
            width={77}
            height={20}
            alt="닫기"
            onClick={onClickLogo}
          />
        ) : (
          <IconButton
            className="mobile-close-button"
            type="button"
            onClick={onClickClose}
            ref={closeButtonRef}
          >
            <Close fontSize="small" />
          </IconButton>
        )}
        {subButtonLabel && onClickSubButton && (
          <CustomizedButton
            className="subButton"
            variant="contained"
            onClick={onClickSubButton}
          >
            <CustomizedTypography variant="body2" color="inherit">
              {subButtonLabel}
            </CustomizedTypography>
          </CustomizedButton>
        )}
      </div>
      <div className={titleSection}>
        <div className={titleWrapper} ref={titleWrapperRef}>
          {serviceType && (
            <CustomizedTypography
              className="service-simple-description"
              variant={!matches ? 'h4' : 'body1'}
              color="inherit"
            >
              {`${requestEnumToString(serviceType)} ${
                serviceExtraDescription
                  ? `  •   ${serviceExtraDescription}`
                  : ''
              }`}
            </CustomizedTypography>
          )}
          <CustomizedTypography
            variant={!matches ? 'h1' : 'h3'}
            fontWeight={!matches ? '700' : '500'}
            color="inherit"
          >
            {title}
          </CustomizedTypography>
        </div>
      </div>
      <div className={contentSection} ref={pannelRef}>
        <DraggableControlContext.Provider
          value={{
            initializeStyle
          }}
        >
          {children}
        </DraggableControlContext.Provider>
      </div>
    </div>
  );
};

export default RequestCommonLayout;
